module.exports = __webpack_public_path__ + "static/img/ureter-detail-3.8b7f1df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/ureterpic/ureter-detail-3.jpg
// module id = nD2z
// module chunks = 52